export default "__VITE_PUBLIC_ASSET__975c79b1__"